import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunks
export const fetchContributions = createAsyncThunk(
  'contributions/fetchContributions',
  async (partnerId, { rejectWithValue }) => {
    try {
      // Simulate API call
      const response = await new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            partner_id: partnerId,
            total_contributions: 2500000,
            monthly_contributions: 450000,
            contributions: Array.from({ length: 20 }, (_, i) => ({
              id: `cont_${i + 1}`,
              amount: Math.floor(Math.random() * 100000) + 10000,
              type: ['education', 'health', 'livelihood'][Math.floor(Math.random() * 3)],
              status: ['completed', 'pending', 'processing'][Math.floor(Math.random() * 3)],
              mother_id: `MTH${String(i + 1).padStart(3, '0')}`,
              mother_name: `Mother ${i + 1}`,
              created_at: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString()
            }))
          });
        }, 1000);
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  contributionsData: null,
  isLoading: false,
  error: null,
  lastUpdated: null,
};

const contributionsSlice = createSlice({
  name: 'contributions',
  initialState,
  reducers: {
    clearContributionsError: (state) => {
      state.error = null;
    },
    addContribution: (state, action) => {
      if (state.contributionsData) {
        state.contributionsData.contributions.unshift(action.payload);
        state.contributionsData.total_contributions += action.payload.amount;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContributions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchContributions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.contributionsData = action.payload;
        state.lastUpdated = Date.now();
        state.error = null;
      })
      .addCase(fetchContributions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearContributionsError, addContribution } = contributionsSlice.actions;

// Selectors
export const selectContributions = (state) => state.contributions;
export const selectContributionsData = (state) => state.contributions.contributionsData;
export const selectContributionsLoading = (state) => state.contributions.isLoading;
export const selectContributionsError = (state) => state.contributions.error;
export const selectTotalContributions = (state) => state.contributions.contributionsData?.total_contributions || 0;
export const selectMonthlyContributions = (state) => state.contributions.contributionsData?.monthly_contributions || 0;
export const selectContributionsList = (state) => state.contributions.contributionsData?.contributions || [];

export default contributionsSlice.reducer;
